import * as THREE from "three";
import { useEffect, useRef } from "react";

export default function GridWalls({ scene, dimX, dimZ, GRID_SIZE, cameraRef }) {
  const wallsRef = useRef([]);

  useEffect(() => {
    if (!scene || !dimX || !dimZ || !cameraRef?.current) return;

    const height = 150;
    const thickness = 5;
    const doorWidth = 150;

    const worldWidth = dimX * GRID_SIZE;
    const worldDepth = dimZ * GRID_SIZE;
    const centerZ = -(dimZ / 2) * GRID_SIZE;

    wallsRef.current.forEach((w) => scene.remove(w));
    wallsRef.current = [];

    function createWall(width, depth, posX, posZ, normal, delay = 0) {
      const material = new THREE.MeshStandardMaterial({
        // color: 0x888888,
        color: 0x6cc6d9,
        transparent: true,
        opacity: 1,
      });

      const wall = new THREE.Mesh(
        new THREE.BoxGeometry(width, height, depth),
        material,
      );

      wall.position.set(posX, 0, posZ + centerZ);

      wall.userData.targetY = height / 2;
      wall.userData.normal = normal.clone();
      wall.userData.isWall = true;
      wall.userData.delay = delay;
      wall.userData.startTime = performance.now();

      scene.add(wall);
      wallsRef.current.push(wall);
      return wall;
    }

    function createWallZWithDoor(zPos, normal, delayOffset = 0) {
      const wallTotalWidth = worldWidth + thickness * 2;
      const sideWidth = (wallTotalWidth - doorWidth) / 2;

      createWall(
        sideWidth,
        thickness,
        -wallTotalWidth / 2 + sideWidth / 2,
        zPos,
        normal,
        delayOffset,
      );
      createWall(
        sideWidth,
        thickness,
        wallTotalWidth / 2 - sideWidth / 2,
        zPos,
        normal,
        delayOffset + 50,
      );
    }

    createWallZWithDoor(-worldDepth / 2, new THREE.Vector3(0, 0, -1), 0);
    createWallZWithDoor(worldDepth / 2, new THREE.Vector3(0, 0, 1), 100);
    createWall(
      thickness,
      worldDepth + thickness * 2,
      -worldWidth / 2 - thickness,
      0,
      new THREE.Vector3(-1, 0, 0),
      200,
    );
    createWall(
      thickness,
      worldDepth + thickness * 2,
      worldWidth / 2 + thickness,
      0,
      new THREE.Vector3(1, 0, 0),
      250,
    );

    const tmpVec = new THREE.Vector3();
    let animationId;

    function animateWalls() {
      const now = performance.now();

      wallsRef.current.forEach((wall) => {
        const elapsed = now - wall.userData.startTime - wall.userData.delay;
        if (elapsed > 0) {
          const progress = Math.min(elapsed / 900, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          wall.position.y = eased * wall.userData.targetY;
        }

        tmpVec
          .subVectors(cameraRef.current.position, wall.position)
          .normalize();
        const dot = tmpVec.dot(wall.userData.normal);
        wall.material.opacity = dot > 0 ? 0.25 : 1;
      });

      animationId = requestAnimationFrame(animateWalls);
    }

    animateWalls();

    return () => {
      cancelAnimationFrame(animationId);
      wallsRef.current.forEach((w) => scene.remove(w));
      wallsRef.current = [];
    };
  }, [scene, dimX, dimZ, GRID_SIZE, cameraRef]);

  return null;
}

// import * as THREE from "three";
// import { useEffect, useRef } from "react";

// export default function GridWalls({ scene, dimX, dimZ, GRID_SIZE, cameraRef }) {
//   const wallsRef = useRef([]);

//   useEffect(() => {
//     if (!scene || !dimX || !dimZ || !cameraRef?.current) return;

//     const height = 150;
//     const thickness = 5;
//     const doorWidth = 150;

//     const worldWidth = dimX * GRID_SIZE;
//     const worldDepth = dimZ * GRID_SIZE;
//     const centerZ = -(dimZ / 2) * GRID_SIZE;

//     wallsRef.current.forEach((w) => scene.remove(w));
//     wallsRef.current = [];

//     function createWall(width, depth, posX, posZ, normal, delay = 0) {
//       const material = new THREE.MeshStandardMaterial({
//         // color: 0x888888,
//         color: 0x6cc6d9,
//         transparent: true,
//         opacity: 1,
//       });

//       const wall = new THREE.Mesh(
//         new THREE.BoxGeometry(width, height, depth),
//         material,
//       );

//       wall.position.set(posX, 0, posZ + centerZ);

//       wall.userData.targetY = height / 2;
//       wall.userData.normal = normal.clone();
//       wall.userData.isWall = true;
//       wall.userData.delay = delay;
//       wall.userData.startTime = performance.now();

//       scene.add(wall);
//       wallsRef.current.push(wall);
//       return wall;
//     }

//     function createWallZWithDoor(zPos, normal, delayOffset = 0) {
//       const wallTotalWidth = worldWidth + thickness * 2;
//       const sideWidth = (wallTotalWidth - doorWidth) / 2;

//       createWall(
//         sideWidth,
//         thickness,
//         -wallTotalWidth / 2 + sideWidth / 2,
//         zPos,
//         normal,
//         delayOffset,
//       );
//       createWall(
//         sideWidth,
//         thickness,
//         wallTotalWidth / 2 - sideWidth / 2,
//         zPos,
//         normal,
//         delayOffset + 50,
//       );
//     }

//     createWallZWithDoor(-worldDepth / 2, new THREE.Vector3(0, 0, -1), 0);
//     createWallZWithDoor(worldDepth / 2, new THREE.Vector3(0, 0, 1), 100);
//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       -worldWidth / 2 - thickness,
//       0,
//       new THREE.Vector3(-1, 0, 0),
//       200,
//     );
//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       worldWidth / 2 + thickness,
//       0,
//       new THREE.Vector3(1, 0, 0),
//       250,
//     );

//     const tmpVec = new THREE.Vector3();
//     let animationId;

//     function animateWalls() {
//       const now = performance.now();

//       wallsRef.current.forEach((wall) => {
//         const elapsed = now - wall.userData.startTime - wall.userData.delay;
//         if (elapsed > 0) {
//           const progress = Math.min(elapsed / 900, 1);
//           const eased = 1 - Math.pow(1 - progress, 3);
//           wall.position.y = eased * wall.userData.targetY;
//         }

//         tmpVec
//           .subVectors(cameraRef.current.position, wall.position)
//           .normalize();
//         const dot = tmpVec.dot(wall.userData.normal);
//         wall.material.opacity = dot > 0 ? 0.25 : 1;
//       });

//       animationId = requestAnimationFrame(animateWalls);
//     }

//     animateWalls();

//     return () => {
//       cancelAnimationFrame(animationId);
//       wallsRef.current.forEach((w) => scene.remove(w));
//       wallsRef.current = [];
//     };
//   }, [scene, dimX, dimZ, GRID_SIZE, cameraRef]);

//   return null;
// }

// import * as THREE from "three";
// import { useEffect } from "react";

// export default function GridWalls({ scene, dimX, dimZ, GRID_SIZE, cameraRef }) {
//   useEffect(() => {
//     if (!scene || !dimX || !dimZ || !cameraRef?.current) return;

//     const walls = [];
//     const height = 150;
//     const thickness = 5;
//     const doorWidth = 150;

//     const worldWidth = dimX * GRID_SIZE;
//     const worldDepth = dimZ * GRID_SIZE;
//     const centerZ = -(dimZ / 2) * GRID_SIZE;
//     const tmpVec = new THREE.Vector3();

//     scene.children
//       .filter((o) => o.userData?.isWall)
//       .forEach((o) => scene.remove(o));

//     function createWall(width, depth, posX, posZ, normal) {
//       const material = new THREE.MeshStandardMaterial({
//         color: 0x888888,
//         transparent: true,
//         opacity: 1,
//       });

//       const wall = new THREE.Mesh(
//         new THREE.BoxGeometry(width, height, depth),
//         material,
//       );
//       wall.position.set(posX, height / 2, posZ + centerZ);
//       wall.userData.normal = normal.clone();
//       wall.userData.isWall = true;

//       scene.add(wall);
//       walls.push(wall);
//     }

//     function createWallZWithDoor(zPos, normal) {
//       const wallTotalWidth = worldWidth + thickness * 2;
//       const sideWidth = (wallTotalWidth - doorWidth) / 2;

//       createWall(
//         sideWidth,
//         thickness,
//         -wallTotalWidth / 2 + sideWidth / 2,
//         zPos,
//         normal,
//       );
//       createWall(
//         sideWidth,
//         thickness,
//         wallTotalWidth / 2 - sideWidth / 2,
//         zPos,
//         normal,
//       );
//     }

//     createWallZWithDoor(-worldDepth / 2, new THREE.Vector3(0, 0, -1));
//     createWallZWithDoor(worldDepth / 2, new THREE.Vector3(0, 0, 1));
//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       -worldWidth / 2 - thickness,
//       0,
//       new THREE.Vector3(-1, 0, 0),
//     );
//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       worldWidth / 2 + thickness,
//       0,
//       new THREE.Vector3(1, 0, 0),
//     );

//     let animationId;
//     function updateTransparency() {
//       walls.forEach((wall) => {
//         tmpVec
//           .subVectors(cameraRef.current.position, wall.position)
//           .normalize();
//         const dot = tmpVec.dot(wall.userData.normal);
//         wall.material.opacity = dot > 0 ? 0.25 : 1;
//       });
//       animationId = requestAnimationFrame(updateTransparency);
//     }

//     updateTransparency();

//     return () => {
//       cancelAnimationFrame(animationId);
//       walls.forEach((w) => scene.remove(w));
//     };
//   }, [scene, dimX, dimZ, GRID_SIZE, cameraRef]);

//   return null;
// }

// import * as THREE from "three";
// import { useEffect, useRef } from "react";

// export default function GridWalls({ scene, dimX, dimZ, GRID_SIZE, cameraRef }) {
//   const wallsRef = useRef([]);

//   console.log("GRID_SIZEgggggg", GRID_SIZE);
//   console.log("dimX", dimX);
//   console.log("dimZ", dimZ);

//   useEffect(() => {
//     if (!scene || !dimX || !dimZ || !cameraRef?.current) return;

//     wallsRef.current.forEach((w) => scene.remove(w));
//     wallsRef.current = [];

//     const walls = wallsRef.current;

//     const height = 150;
//     const thickness = 5;
//     const doorWidth = 150;

//     const worldWidth = dimX * GRID_SIZE;
//     const worldDepth = dimZ * GRID_SIZE;
//     const centerZ = -(dimZ / 2) * GRID_SIZE;

//     function createWall(width, depth, posX, posZ, normal) {
//       const material = new THREE.MeshStandardMaterial({
//         color: 0x888888,
//         transparent: true,
//         opacity: 1,
//       });

//       const wall = new THREE.Mesh(
//         new THREE.BoxGeometry(width, height, depth),
//         material,
//       );
//       wall.position.set(posX, height / 2, posZ + centerZ);
//       wall.userData.normal = normal.clone();

//       scene.add(wall);
//       walls.push(wall);
//     }

//     function createWallZWithDoor(zPos, normal) {
//       const wallTotalWidth = worldWidth + thickness * 2;
//       const sideWidth = (wallTotalWidth - doorWidth) / 2;

//       createWall(
//         -sideWidth,
//         thickness,
//         -wallTotalWidth / 2 + sideWidth / 2,
//         zPos,
//         normal,
//       );
//       createWall(
//         sideWidth,
//         thickness,
//         wallTotalWidth / 2 - sideWidth / 2,
//         zPos,
//         normal,
//       );
//     }

//     createWallZWithDoor(-worldDepth / 2, new THREE.Vector3(0, 0, -1));
//     createWallZWithDoor(worldDepth / 2, new THREE.Vector3(0, 0, 1));
//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       -worldWidth / 2 - thickness,
//       0,
//       new THREE.Vector3(-1, 0, 0),
//     );
//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       worldWidth / 2 + thickness,
//       0,
//       new THREE.Vector3(1, 0, 0),
//     );

//     const tmpVec = new THREE.Vector3();

//     function updateTransparency() {
//       walls.forEach((wall) => {
//         tmpVec
//           .subVectors(cameraRef.current.position, wall.position)
//           .normalize();
//         const dot = tmpVec.dot(wall.userData.normal);
//         wall.material.opacity = dot > 0 ? 0.25 : 1;
//       });
//     }

//     let animationId;
//     function animate() {
//       updateTransparency();
//       animationId = requestAnimationFrame(animate);
//     }
//     animate();

//     return () => {
//       wallsRef.current.forEach((w) => scene.remove(w));
//       cancelAnimationFrame(animationId);
//     };
//   }, [scene, dimX, dimZ, GRID_SIZE, cameraRef]);

//   return null;
// }

// import * as THREE from "three";
// import { useEffect } from "react";

// export default function GridWalls({
//   scene,
//   dimX,
//   dimZ,
//   GRID_SIZE,
//   cameraRef,
//   showDebug = false,
// }) {
//   useEffect(() => {
//     if (!scene || !dimX || !dimZ || !cameraRef?.current) return;

//     const walls = [];
//     const height = 150;
//     const thickness = 5;
//     const doorWidth = 150;
//     const worldWidth = dimX * GRID_SIZE;
//     const worldDepth = dimZ * GRID_SIZE;
//     const centerZ = -(dimZ / 2) * GRID_SIZE;

//     const tmpVec = new THREE.Vector3();

//     function createWall(width, depth, posX, posZ, normal) {
//       const material = new THREE.MeshStandardMaterial({
//         color: 0x888888,
//         transparent: true,
//         opacity: 1,
//       });

//       const wall = new THREE.Mesh(
//         new THREE.BoxGeometry(width, height, depth),
//         material,
//       );
//       wall.position.set(posX, height / 2, posZ + centerZ);
//       wall.userData.normal = normal.clone();

//       scene.add(wall);
//       walls.push(wall);

//       if (showDebug) {
//         const axesHelper = new THREE.AxesHelper(50);
//         wall.add(axesHelper);
//       }

//       console.log(
//         "Dodano ścianę:",
//         wall.position.toArray(),
//         "normal:",
//         normal.toArray(),
//       );
//     }

//     function createWallZWithDoor(zPos, normal) {
//       const wallTotalWidth = worldWidth + thickness * 2;
//       const sideWidth = (wallTotalWidth - doorWidth) / 2;

//       createWall(
//         sideWidth,
//         thickness,
//         -wallTotalWidth / 2 + sideWidth / 2,
//         zPos,
//         normal,
//       );

//       createWall(
//         sideWidth,
//         thickness,
//         wallTotalWidth / 2 - sideWidth / 2,
//         zPos,
//         normal,
//       );
//     }

//     createWallZWithDoor(-worldDepth / 2, new THREE.Vector3(0, 0, -1));
//     createWallZWithDoor(worldDepth / 2, new THREE.Vector3(0, 0, 1));

//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       -worldWidth / 2 - thickness,
//       0,
//       new THREE.Vector3(-1, 0, 0),
//     );

//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       worldWidth / 2 + thickness,
//       0,
//       new THREE.Vector3(1, 0, 0),
//     );

//     let frameId;

//     function updateTransparency() {
//       const cameraPos = cameraRef.current.position;
//       walls.forEach((wall, index) => {
//         tmpVec.subVectors(cameraPos, wall.position).normalize();
//         const dot = tmpVec.dot(wall.userData.normal);

//         wall.material.opacity = dot > 0 ? 0.25 : 1;

//         if (showDebug) {
//           console.log(
//             `Ściana ${index}: kamera=${cameraPos.toArray()}, wall=${wall.position.toArray()}, normal=${wall.userData.normal.toArray()}, dot=${dot.toFixed(3)}, opacity=${wall.material.opacity}`,
//           );
//         }
//       });

//       frameId = requestAnimationFrame(updateTransparency);
//     }

//     updateTransparency();

//     return () => {
//       cancelAnimationFrame(frameId);
//       walls.forEach((w) => scene.remove(w));
//     };
//   }, [scene, dimX, dimZ, GRID_SIZE, cameraRef, showDebug]);

//   return null;
// }

// import * as THREE from "three";
// import { useEffect } from "react";

// export default function GridWalls({ scene, dimX, dimZ, GRID_SIZE }) {
//   useEffect(() => {
//     if (!scene || !dimX || !dimZ) return;

//     console.log("scene", scene);
//     console.log("dimX", dimX);
//     console.log("dimZ", dimZ);

//     const walls = [];

//     const height = 150;
//     const thickness = 5;

//     const doorWidth = 150;

//     const worldWidth = dimX * GRID_SIZE;
//     const worldDepth = dimZ * GRID_SIZE;
//     const centerZ = -(dimZ / 2) * GRID_SIZE;

//     function createWall(width, depth, posX, posZ) {
//       const wall = new THREE.Mesh(
//         new THREE.BoxGeometry(width, height, depth),
//         new THREE.MeshStandardMaterial({ color: 0x888888 }),
//       );
//       wall.position.set(posX, height / 2, posZ + centerZ);
//       scene.add(wall);
//       walls.push(wall);
//     }

//     function createWallZWithDoor(zPos) {
//       const leftWidth = worldWidth / 2 + thickness - doorWidth / 2;
//       const rightWidth = leftWidth;

//       createWall(
//         leftWidth,
//         thickness,
//         -worldWidth / 2 - thickness + leftWidth / 2,
//         zPos,
//       );

//       createWall(
//         rightWidth,
//         thickness,
//         worldWidth / 2 + thickness - rightWidth / 2,
//         zPos,
//       );
//     }

//     createWallZWithDoor(-worldDepth / 2);
//     createWallZWithDoor(worldDepth / 2);

//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       -worldWidth / 2 - thickness,
//       0,
//     );

//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       worldWidth / 2 + thickness,
//       0,
//     );

//     return () => walls.forEach((w) => scene.remove(w));
//   }, [scene, dimX, dimZ, GRID_SIZE]);

//   return null;
// }

// import * as THREE from "three";
// import { useEffect } from "react";

// export default function GridWalls({ scene, boardSizeRef, GRID_SIZE }) {
//   useEffect(() => {
//     if (!scene || !boardSizeRef) return;

//     const { dimX, dimZ } = boardSizeRef;
//     if (!dimX || !dimZ) return;

//     const walls = [];

//     const height = 150;
//     const thickness = 5;

//     const doorWidth = 150;
//     const doorOffsetX = 0;

//     const worldWidth = dimX * GRID_SIZE;
//     const worldDepth = dimZ * GRID_SIZE;

//     const centerZ = -(dimZ / 2) * GRID_SIZE;

//     function createWall(width, depth, posX, posZ) {
//       const geom = new THREE.BoxGeometry(width, height, depth);
//       const mat = new THREE.MeshStandardMaterial({ color: 0x888888 });
//       const wall = new THREE.Mesh(geom, mat);

//       wall.position.set(posX, height / 2, posZ + centerZ);

//       scene.add(wall);
//       walls.push(wall);
//     }

//     function createWallZWithDoor(zPos, doorGridX = 0) {
//       const doorCenterX = doorGridX * GRID_SIZE;

//       const leftWidth =
//         worldWidth / 2 + thickness - (doorCenterX + doorWidth / 2);

//       const rightWidth =
//         worldWidth / 2 + thickness + (doorCenterX - doorWidth / 2);

//       if (leftWidth > 0) {
//         createWall(
//           leftWidth,
//           thickness,
//           -worldWidth / 2 - thickness + leftWidth / 2,
//           zPos,
//         );
//       }

//       if (rightWidth > 0) {
//         createWall(
//           rightWidth,
//           thickness,
//           worldWidth / 2 + thickness - rightWidth / 2,
//           zPos,
//         );
//       }
//     }

//     createWallZWithDoor(-worldDepth / 2, 0);
//     createWallZWithDoor(worldDepth / 2, 0);

//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       -worldWidth / 2 - thickness,
//       0,
//     );

//     createWall(
//       thickness,
//       worldDepth + thickness * 2,
//       worldWidth / 2 + thickness,
//       0,
//     );

//     return () => {
//       walls.forEach((w) => scene.remove(w));
//     };
//   }, [scene, boardSizeRef, GRID_SIZE]);

//   return null;
// }

// import * as THREE from "three";
// import { useEffect } from "react";

// export default function GridWalls({ scene, boardSizeRef, GRID_SIZE }) {
//   useEffect(() => {
//     if (!scene || !boardSizeRef) return;

//     const { dimX, dimZ } = boardSizeRef;
//     const walls = [];

//     if (!dimX || !dimZ) return;

//     const height = 50;
//     const thickness = 5;

//     function createWall(width, depth, posX, posZ) {
//       const geom = new THREE.BoxGeometry(width, height, depth);
//       const mat = new THREE.MeshStandardMaterial({ color: 0x888888 });
//       const wall = new THREE.Mesh(geom, mat);
//       const centerZ = -(dimZ / 2) * GRID_SIZE;
//       wall.position.set(posX, height / 2, posZ + centerZ);
//       scene.add(wall);
//       walls.push(wall);
//     }

//     const worldWidth = dimX * GRID_SIZE;
//     const worldDepth = dimZ * GRID_SIZE;

//     createWall(worldWidth + thickness * 2, thickness, 0, -worldDepth / 2);
//     createWall(worldWidth + thickness * 2, thickness, 0, worldDepth / 2);

//     createWall(thickness, worldDepth + thickness * 2, -worldWidth / 2, 0);
//     createWall(thickness, worldDepth + thickness * 2, worldWidth / 2, 0);

//     return () => {
//       walls.forEach((w) => scene.remove(w));
//     };
//   }, [scene, boardSizeRef, GRID_SIZE]);

//   return null;
// }
